import React from 'react';
import { SimpleDialog, Typography, styled } from '@nextiva/next-ui-components';

const StyledSimpleDialog = styled(SimpleDialog)`
  z-index: 1400;
`;
const StyledDialogText = styled(Typography)`
  width: 100%;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

interface ISaveUserChangesModal {
  onSaveButtonClick: () => void;
  onCancelButtonClick: () => void;
}

export const SaveUserChangesModal = ({
  onSaveButtonClick,
  onCancelButtonClick,
}: ISaveUserChangesModal) => (
  <StyledSimpleDialog
    data-testid="PlatformAdminUI-ManageUserDrawer-SaveChangesModal"
    dialogProps={{
      'aria-label': 'Save Changes',
      disablePortal: true,
      disableScrollLock: true,
    }}
    cancelButtonProps={{
      onClick: () => onCancelButtonClick(),
      'data-testid':
        'PlatformAdminUI-ManageUserDrawer-SaveChangesModal-CancelButton',
    }}
    cancelText="Cancel"
    confirmButtonProps={{
      color: 'primary',
      onClick: () => onSaveButtonClick(),
      'data-testid':
        'PlatformAdminUI-ManageUserDrawer-SaveChangesModal-SaveButton',
    }}
    confirmText="Yes, save changes"
    title="Save Changes?"
    open
  >
    <StyledDialogText variant="body2">
      You have unsaved changes that have been made.
    </StyledDialogText>
    <StyledDialogText variant="body2">
      Are you sure you want to take this action?
    </StyledDialogText>
  </StyledSimpleDialog>
);
